import React from 'react';
import { Form } from 'react-final-form';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import SelectedMedia from './selected-media/SelectedMedia';
import MediaPool from './media-pool/MediaPool';
import UsedMedia from './used-media/UsedMedia';
import MessageSection from './message-section/MessageSection';
import ParamsSection from './params-section/ParamsSection';
import { STORY_FORM_FIELDS } from '../constants';
import validate from '../../../utils/validate';
import { storyFormValidation } from './validation';
import { STORY_PLATFORM_TYPES } from '../../../constants';
import { useProject } from '../../../context/ProjectContext';

import scss from './AdjustForm.module.scss';

function AdjustForm() {
  const { actions } = useProject();
  const { id: projectId } = useParams();

  const selectedMessage = useSelector((state) => state.story.selectedMessage);
  const selectedMedia = useSelector((state) => state.story.selectedMedia);

  const handleSubmit = async (values) => {
    await actions('generateStory', { ...values, projectId });
  };

  const initialValues = {
    [STORY_FORM_FIELDS.MEDIA]: selectedMedia ?? [],
    [STORY_FORM_FIELDS.MESSAGE]: selectedMessage ?? '',

    [STORY_PLATFORM_TYPES.LINKEDIN]: [],
    [STORY_PLATFORM_TYPES.YOUTUBE]: [],
    [STORY_PLATFORM_TYPES.META]: [],
    [STORY_PLATFORM_TYPES.BANNERS]: [],
    [STORY_PLATFORM_TYPES.OTHER_SOCIALS]: [],
    [STORY_PLATFORM_TYPES.LONG_FORM]: [],
  };

  return (
    <Form
      initialValues={initialValues}
      onSubmit={handleSubmit}
      keepDirtyOnReinitialize
      validate={(values) => validate(values, storyFormValidation())}
      render={({ handleSubmit }) => (
        <form className={scss.wrapper} onSubmit={handleSubmit}>
          <div className={scss.grid}>
            <div className={scss.leftColumn}>
              <SelectedMedia />
              <MessageSection />
            </div>

            <div className={scss.rightColumn}>
              <MediaPool />
              <UsedMedia />
            </div>

            <div className={scss.params}>
              <ParamsSection />
            </div>
          </div>
        </form>
      )}
    />
  );
}

export default AdjustForm;
